import React from "react";
import { device, mq } from "lib/media-query";
import styled, { css } from "styled-components";

const scrollOffset = () =>
    typeof window !== "undefined"
        ? window.pageYOffset
        : typeof document !== "undefined"
        ? document?.body?.scrollTop
        : 0;

interface SearchCompProps extends React.HTMLProps<HTMLDivElement> {
    advanced: boolean;
}

export const Search = styled.div<SearchCompProps>`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.tertiary[100]};
    // background-color: #fafafa;
    max-width: 1328px;
    box-sizing: border-box;
    z-index: 10;

    ${({ advanced }) =>
        advanced
            ? css`
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  padding: 8px 0;
                  top: ${280 - scrollOffset()}px;
                  margin-bottom: 74px;
                  // the 100px padding is so the fixed bar at the bottom doesn't cover the lowest filter controls
                  padding: 16px 16px 100px 16px;

                  ${mq.from(device.TABLET_LANDSCAPE)`
            top: ${376 - scrollOffset()}px;
          `}
              `
            : ""}
`;
